<template>
    <loader v-if="loading" />
    <div v-else>
        <v-row justify="space-between">
            <v-col cols="12">
                <v-tabs dark background-color="third" grow v-model="$store.state.reports.reportTab">
                    <v-tab v-for="(report, index) in $store.state.reports.reports" :key="index">{{ report.name }}</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row justify="space-between" align="center">
            <v-col cols="6" class="d-flex">
                <v-btn-toggle
                v-model="$store.state.reports.tab"
                class="d-flex justify-space-between elevation-2">
                    <v-btn
                        v-for="(tab, index) in $store.state.reports.tabs"
                        :key="index"
                        class="px-6"
                        :color="$store.state.reports.tab === index ? 'secondary' : 'white'"
                        active-class="white--text"
                    >
                        <v-icon left :color="$store.state.reports.tab === index ? 'white' : 'default'">{{ tab.icon }}</v-icon>
                        {{ tab.text }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
                <range-picker :solo="true" storeName="reports" rangeName="range" periodName="period" :presets="presets" />
            </v-col>
		</v-row>
        <v-divider v-if="$store.getters['reports/currentReport'].type === 'grouped'"></v-divider>
        <v-row v-if="$store.getters['reports/currentReport'].type === 'grouped'">
            <v-col>
                <v-sheet>
                    <v-slide-group show-arrows v-model="$store.state.reports.groupIndex" mandatory>
                        <v-slide-item
                            v-for="(group, index) in [ { name: 'Alle grupper', _id: '123' }, ...$store.getters['reports/currentReport'].groups]"
                            :key="group._id"
                            v-slot:default="{ active, toggle }"
                        >
                            <v-btn
                                :class="{'ml-0' : index === 0, 'mr-0' : index === $store.getters['reports/currentReport'].groups.length}"
                                class="mx-2"
                                :input-value="active"
                                active-class="third darken-3 white--text"
                                depressed
                                @click="toggle"
                            >
                            {{ group.name }}
                            </v-btn>
                        </v-slide-item>
                    </v-slide-group>
                </v-sheet>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <stats-report v-if="$store.state.reports.tab === 0" />
        <development-report v-else-if="$store.state.reports.tab === 1" />
        <service-report v-else-if="$store.state.reports.tab === 2" />
        <leads-report v-else-if="$store.state.reports.tab === 3" />
    </div>
</template>

<script>
import RangePicker from "@/components/rangePicker"
import StatsReport from "@/views/Reports/StatsReport"
import DevelopmentReport from "@/views/Reports/developmentReport"
import ServiceReport from "@/views/Reports/ServiceReport"
import LeadsReport from "@/views/Reports/LeadsReport"

export default {
	components: {
        RangePicker,
        StatsReport,
        DevelopmentReport,
        ServiceReport,
        LeadsReport
    },
    data () {
        return {
            loading: true
        }
    },
	computed: {
		period() {
			return this.$store.state.reports.period;
        },
        presets () {
            return this.$store.state.reports.presets
        },
        reportTab () {
            return this.$store.state.reports.reportTab
        }
    },
    methods: {
        async getData () {
            this.loading = true
            let response = await this.$http().get('/reports/config')
            this.$store.state.reports.reports = response.data
        }
    },
    watch: {
        period: function () {
            this.$store.commit("reports/setRange", this.$store.state.reports.period);
        },
        report () {
            history.pushState({}, null, this.$route.path + '?report=' + this.$store.getters['reports/currentReport']._id)
        },
        reportTab () {
            history.pushState({}, null, this.$route.path + '?report=' + this.$store.getters['reports/currentReport']._id)
        }
    },
	async created() {
        this.$store.commit("reports/setRange", this.$store.state.reports.period);
        await this.getData()
        if (this.$route.query.report) {
            this.$store.state.reports.reportTab = this.$store.state.reports.reports.findIndex(report => report._id === this.$route.query.report)
        } else {
            history.pushState({}, null, this.$route.path + '?report=' + this.$store.getters['reports/currentReport']._id)
        }
        this.loading = false
	}
}
</script>

<style lang="scss" scoped>
.view-selector {
$tab-color: #05668D;

    .v-tab {
        color:  $tab-color !important;
        border: 1px solid $tab-color;
        border-radius: 5px;

        i {
            color:  $tab-color !important;
        }
    }

    .v-tab--active {
        color: white !important;
        background: $tab-color;


        i {
            color:  white !important;
        }
    }
}
</style>